import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => props => {
  const navigate = hooks.useNavigate()

  const onRowClick = useCallback(row => navigate(`/list/${row?.list_id}`), [navigate])
  const onClickNewImport = useCallback(() => navigate('/import'), [navigate])

  const mergedProps = {
    onClickNewImport,
    onRowClick
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
